import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {  Reportlogin } from "../../../actions/AuthAction";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../Loader/Loader"

const MobileReports = () => {

//   const weburl = `http://localhost:3000/mobile-reports/4041/fee-collection`;

  const url = window.location.hostname;
  const [loading ,setLoading] = useState(false)

const { userID, reportPath } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const loginRedirect = async () => {
      setLoading(true)
      localStorage.clear();

      let data = {
        user_id: userID,
          access_url: url,
        // access_url: "localhost",
      };

      try {
        let res = await dispatch(Reportlogin(data));
        if (res.status === 200) {
          const currentTime = new Date().getTime();
          localStorage.setItem("loginTime", currentTime);
          localStorage.setItem("token", res.temp_dict.token);
          localStorage.setItem("User", JSON.stringify(res.temp_dict.user_type));
          localStorage.setItem("school_user", JSON.stringify(res.temp_dict));
          localStorage.setItem("userRedirectionfromMobile", true);
          
          navigate(`/school/${reportPath}`)
          window.location.reload();
        } else if (res.status === 403 || res.status === 503) {
          Swal.fire({
            text: res.msg,
            icon: "error",
            imageAlt: "error image",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(true)
      }
    };

    useEffect(() => {
      loginRedirect();
    }, []);



 
  return <div><Loader/></div>;
};

export default MobileReports;
